<template>
  <div class="inventoryRp">
      <el-dialog
        :title="$t('other.a1818')"
        :visible.sync="dialogVisible"
        width="50%"
        >
        <div class="pong">
            <div :class="{'okng':true,'active':dataOfType == 30 }" @click="getDataOfType(30)">{{$t('other.a1823')}}</div>
            <div :class="{'okng':true,'active':dataOfType == 7 }" @click="getDataOfType(7)">{{$t('other.a1824')}}</div>
            <div :class="{'okng':true,'active':dataOfType == 3 }" @click="getDataOfType(3)">{{$t('other.a1825')}}</div>
            <div class="block">
                <el-date-picker
                size="mini"
                v-model="value6"
                value-format="yyyy-MM-dd"
                type="daterange"
                @change="getTime()"
                :range-separator="$t('other.a47')"
                :start-placeholder="$t('other.a45')"
                :end-placeholder="$t('other.a46')">
                </el-date-picker>
            </div>
            <div style="margin-left:20px">
                {{$t('other.a1826')}}：{{totalAmount}}
            </div>
        </div>
        <div id="main" ref="mainBox" class="iknkg"></div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">{{$t('other.a5')}}</el-button>
        </span>
      </el-dialog>

      <div class="desc">
         <div class="itemWrapper">
             <div class="store">{{$t('other.a1827')}}</div>
             <div>
                <span :class="{'sokng':true,'active':storeId == item.value}" @click="getData(item)" v-for="(item,index) in storeList" :key="index">{{item.label}}</span>
             </div>
         </div>
         <div >
             <span class="store">{{$t('other.a1346')}}</span>
             <span :class="{'sokng':true,'active':type == item.type}" v-if="!item.hide"   @click="type = item.type,page = 0,getType()" v-for="(item,index) in timeList" :key="index" >{{item.label}}<span v-if="item.num > -1">(x{{item.num}})</span></span>
             <span class="uykpg" @click="exportXlm()">{{$t('other.a1828')}}</span>
         </div>
      </div>
      <div class="remindData">
          <div style="display:flex">
              <div v-show="type == 1">{{$t('other.a1829')}}：<el-input style="width:120px"  size="mini" v-model="dayofship" ></el-input></div>
              <div><el-button v-show="type == 1" style="margin-left:20px" size="mini" @click="upataOutOfStack({dayOfShip:dayofship,type:radio})" type="primary">{{$t('other.a274')}}</el-button></div>
              <div><el-checkbox v-show="type == 1" style="padding-left: 10px;" @change="upataOutOfStack({dayOfShip:dayofship,type:radio})" v-model="radio">{{$t('other.a167')}}</el-checkbox></div>
          </div>
          <div class="btn">
              {{$t('other.a1830')}}：<el-input size="mini" style="width:350px" v-model="cusCode" :placeholder="$t('other.a1831')"></el-input>
          </div>
          
      </div>
      <div style="margin:10px 0;">
          <span style="margin-right:30px;">{{$t('other.a964')}}{{stockReminder}}{{$t('other.a707')}}</span>
          <el-button size="mini" type="primary" @click="createPurchase()">{{$t('other.a1832')}}</el-button>
          <span class="purchaseNum">{{multipleSelection.length}}</span>
      </div>
      <div>
          
          <el-table 
					:data="orderList" 
                    :row-key="(row) => row.cusCode"
                    @sort-change="changeSort"
                    @selection-change="handleSelectionChange"
					ref="multipleTable"
					border>

                    <el-table-column
						  type="selection"
                          :reserve-selection="true"
						  width="55">
						</el-table-column>

						<el-table-column property="name" :label="$t('other.a66')" width="60" fixed :show-overflow-tooltip="true">
							<template scope="scope">
								<el-popover placement="top-start" title="" trigger="hover">
									<img :src="scope.row.storeItem.image" style="width: 150px;height: 150px" />
									<img slot="reference" :src="scope.row.storeItem.image" style="width: 30px;height: 30px">
								</el-popover>
							</template>
						</el-table-column>
						
						<el-table-column property="storeItem.skuName" fixed label="sku"  :show-overflow-tooltip="true"></el-table-column>
                        <el-table-column property="storeItem.cusCode" fixed :label="$t('other.a67')"  :show-overflow-tooltip="true"></el-table-column>
						<el-table-column :label="$t('other.a168')" v-if="type == 1" sortable prop="needStock01" :show-overflow-tooltip="true">
							<template scope="scope" >
								<span>{{scope.row.needStock01}}</span>
							</template>
						</el-table-column >
                        <el-table-column :label="$t('other.a1819')" sortable='custom' prop="shippedStock"  :show-overflow-tooltip="true">
							<template scope="scope">
								<span>{{scope.row.goodsValue}}</span>
							</template>
						</el-table-column>
						<el-table-column :label="$t('other.a1820')" sortable='custom'  prop="nowStock" :show-overflow-tooltip="true">
							<template scope="scope">
								<span>{{scope.row.nowStock}}</span>
							</template>
						</el-table-column>
						<el-table-column :label="$t('other.a170')" sortable='custom' prop="shippedStock"  :show-overflow-tooltip="true">
							<template scope="scope">
								<span>{{scope.row.shippedStock}}</span>
							</template>
						</el-table-column>
                        
                        <!-- <el-table-column label="平均销量/天(近30天)" sortable='custom' prop="salesAvgMonthly"  :show-overflow-tooltip="true">
							<template scope="props">
								<span>{{props.row.salesAvgMonthly}}</span>
							</template>
						</el-table-column> -->
						<el-table-column :label="$t('other.a1821')" sortable='custom'  prop="salesAvg01"  :show-overflow-tooltip="true">
							<template scope="scope">
								<span>{{scope.row.salesAvg01}}</span>
							</template>
						</el-table-column>
                        <el-table-column :label="$t('other.a173')"  sortable='custom' prop="sevenday_estimatedSales">
							<template scope="scope">
								<span>{{scope.row.sevenday_estimatedSales ? scope.row.sevenday_estimatedSales : '0'}}</span>
							</template>
						</el-table-column>
						<el-table-column :label="$t('other.a174')"  sortable='custom' prop="fourteenday_estimatedSales">
							<template scope="scope">
								<span>{{scope.row.fourteenday_estimatedSales ? scope.row.fourteenday_estimatedSales :'0'}}</span>
							</template>
						</el-table-column>
						<el-table-column :label="$t('other.a175')"  sortable='custom' prop="thirty_estimatedSales">
							<template scope="scope">
								<span>{{scope.row.thirty_estimatedSales ? scope.row.thirty_estimatedSales : '0'}}</span>
							</template>
						</el-table-column>
						<el-table-column :label="$t('other.a176')"  sortable='custom' prop="daysAvailableSale">
							<template scope="scope">
								<span>{{scope.row.daysAvailableSale ? scope.row.daysAvailableSale : '0'}}</span>
							</template>
						</el-table-column>
                        <el-table-column :label="$t('other.a181')" sortable='custom' prop="lastTime"  :show-overflow-tooltip="true">
							<template scope="scope">
								<span>{{scope.row.lastTime}}</span>
							</template>
						</el-table-column>
                        <el-table-column :label="$t('other.a1822')" sortable='custom' prop="shippedStock"  :show-overflow-tooltip="true">
							<template scope="scope">
								<span>{{scope.row.lastInHouseTime}}</span>
							</template>
						</el-table-column>
						<el-table-column width="180">
							<template scope="scope">
								<el-button size="mini" type="primary" @click="viewSales(scope.row)">{{$t('other.a1833')}}</el-button>
							</template>
						</el-table-column>
					</el-table>

             <div class="pagination">

                 <el-pagination
                background
                size="mini"
                @current-change="handleCurrentChange"
                layout="prev, pager, next"
                :total="stockReminder">
                </el-pagination>
             </div>       
      </div>
  </div>
</template>

<script>
import utils from '../../utils/utils'
import userStoreItems from '../../api/moudles/userStoreItems'
import * as echarts from 'echarts';
import { mapState, mapActions, mapMutations} from 'vuex'
export default {
data(){
return{
    radio:false,
    dialogVisible:false,
    dayofship:7,
    remindData:[],
    multipleSelection:[],
    mainItem:null,
    dataOfType:30,
    storeoperaterecord:[],
    storeItemlist:[],
    storeoperaterecordcount:0,
    cusCode:null,
    type:0,
    stockReminder:0,
    outOfstockReminder:[],
    unsalable:[],
    storeList:[],
    storeId:null,
    totalAmount:0,
    userId:null,
    hideAllText:false,
    value6:'',
    page:0,
    userInfo:JSON.parse(localStorage.getItem('userInfo')),
    timeList:[{
        label:this.$t('other.a358'),
        type:0,
        num:-1,
        hide:false,
    },{
        label:this.$t('other.a202'),
        type:1,
        num:0,
        hide:false,
    },{
        label:this.$t('other.a203'),
        type:2,
        num:0,
        hide:false,
    }],
    option: {
        xAxis: {
            type: 'category',
            data: []
        },
        yAxis: {
            type: 'value'
        },
        series: [
            {
            data: [],
            type: 'line',
            smooth: true
            }
        ]
        }
}
},
computed:{
    orderList(){
        let list=[]
        if(this.type == 0){
            list=JSON.parse(JSON.stringify(this.remindData))
            
        }else if(this.type == 1){
            list=JSON.parse(JSON.stringify(this.outOfstockReminder))
            
        }else{
            list=JSON.parse(JSON.stringify(this.unsalable))
        }

        let list2=[]
         let cusCode=this.cusCode

        if(cusCode && cusCode !== ' ' && cusCode !== null){
            
            list.forEach(p => {
                if(
                    this.fuzzyMatch(cusCode.trim(),p.storeItem.skuName)
                    || this.fuzzyMatch(cusCode.trim(),p.storeItem.cusCode)
                ){
                    list2.push(p)
                }
            })
            console.log('list2',list2)
            this.stockReminder=list2.length
            return list2
          
        }else{
            list2=list
            this.stockReminder=list2.length
            let listCopy=list2.splice(this.page,10)

        
            console.log('cusCode',this.cusCode)

            return listCopy
        }
    },
},
created(){
    let stockType=this.$route.query.stockType
    this.type = stockType ? stockType : 0
    if(stockType){
        this.timeList[0].hide=true
    }
    this.storeId=utils.getDefalultStoreId()
    this.userId=this.userInfo ? this.userInfo.userId : null 
    this.storeList=utils.getStore()
    console.log('storeList',this.storeList)
    this.getStockRemindCopy()

},
methods:{

    ...mapActions('userStoreItems', [
        'getStockRemind',
    ]),

    handleSelectionChange(val) {
        this.multipleSelection = val;
        console.log(this.multipleSelection)
    },

    //创建采购单 
		  createPurchase(){
			  if(!this.multipleSelection.length) {
				  this.$message.error(this.$t('other.a211'))
				  return
			  }

			  let list=[]
			  this.multipleSelection.forEach(p => {
				  p.storeItem.variation={
							variationId: 0,
							name: '',
							stock: 0
						}
				 p.storeItem.num=Number(p.needStock01)
				  list.push(p.storeItem)
			  })

			  localStorage.setItem('purchaseItems',JSON.stringify(list))

			  console.log(this.multipleSelection)
			  this.$router.push({
				  path:'/purchaseDetail',
				  query:{
					  storeId:this.multipleSelection[0].storeItem.storeId,
                      type:this.$route.query.type,
                      stockType:this.$route.query.stockType,
				  }
			  })
		
		  },

    exportXlm(){
        let list=null
        if(this.type == 0){
            list=this.remindData
        }else if(this.type == 1){
            list=this.outOfstockReminder
        }else if(this.type == 2){
            list=this.unsalable
        }

        let arr=[]

        
        list.forEach(p => {
            arr.push({
                'sku名称':p.storeItem.skuName,
                'cusCode':p.storeItem.cusCode,
                '货值':p.goodsValue,
                '在仓库存':p.nowStock,
                '在途数量':p.shippedStock,
                '近7天的销量':p.salesAvg.toFixed(2),
                '7天预估销量':p.sevenday_estimatedSales,
                '14天预估销量':p.fourteenday_estimatedSales,
                '30天预估销量':p.thirty_estimatedSales,
                '剩余可销售天数':p.daysAvailableSale,
                '最近出库时间':p.lastTime,
                '最近入库的时间':this.$t("other.a354"),
               
            })
        })

        let list2=['sku名称','cusCode','在仓库存','在途数量','货值','近7天的销量','7天预估销量','14天预估销量','30天预估销量','剩余可销售天数','最近出库时间','最近入库的时间']

        utils.exPortEXml(arr,list2,list2)
        console.log('list',list)
    },

    changeSort(val){
        console.log('jkdfn',val)
         if(this.type == 0){
            let list=JSON.parse(JSON.stringify(this.remindData))

             this.sortOrderData(list,val.order,val.prop)
            
        }else if(this.type == 1){
            let list=JSON.parse(JSON.stringify(this.outOfstockReminder))
            this.sortOrderData(list,val.order,val.prop)
            
        }else{
            let list=JSON.parse(JSON.stringify(this.unsalable))
            this.sortOrderData(list,val.order,val.prop)
        }
    },

    sortOrderData(arr,order=null,type){
        let list=arr
        if(order == 'ascending'){
            arr.sort((a,b) => {
                return a[type]-b[type]
            })
        }else if(order == 'descending'){
            arr.sort((a,b) => {
                return b[type]-a[type]
            })
        }

        if(this.type ==0 ){
            this.remindData=arr
        }else if(this.type == 1){
            this.outOfstockReminder=arr
        }else{
            this.unsalable=arr
        }

        

        console.log('list',list)


    },



    getTime(){
        console.log(this.value6)
        let value=utils.getDaysBetween(this.value6[0],this.value6[1])
        let todata=utils.getTodayDate()
        let value2=utils.getDaysBetween(this.value6[1],todata)
        console.log('value',value)
        let arr=[]
        let list2=[]
        let ttp=utils.getRecentSevenDay(-value2)
        arr.push(ttp)

        for(let i=1;i<value+1;i++){
            arr.unshift(utils.getRecentSevenDay(-i-value2))
            list2.unshift(0)
            
        }

        this.option.xAxis.data=arr
        this.option.series[0].data=list2

        this.lgnk(this.mainItem,arr[0],arr[arr.length-1])

        console.log('artr',arr)


    },

    getDataOfType(num){
        
        this.dataOfType=Number(num)
        let list=[]
        let list2=[]

        for(let i=0;i<this.dataOfType;i++){
            list.unshift(utils.getRecentSevenDay(-i))
            list2.unshift(0)
        }

        this.value6=[list[0],list[list.length-1]]

        this.option.xAxis.data=list
        this.option.series[0].data=list2

        this.lgnk(this.mainItem)
        console.log('option',this.option)
    },

    viewSales(item){

    this.dialogVisible=true
    this.mainItem=item
    let list=[]
    let list2=[]

    for(let i=0;i<this.dataOfType;i++){
        list.unshift(utils.getRecentSevenDay(-i))
        list2.unshift(0)
    }

    this.value6=[list[0],list[list.length-1]]

    this.option.xAxis.data=list
    this.option.series[0].data=list2
    
    this.$nextTick(() => {
        this.lgnk(item)
    });  
    },

    lgnk(item,start=null,end=null){
        let that=this
        var chartDom = document.querySelector('#main')
        var myChart = echarts.init(chartDom);
        let params={
            cusCode:item.cusCode,
            end:end ? utils.CurdateAddoneday(end) : utils.CurdateAddoneday(utils.getRecentDays(0)),
            start: start ? start : utils.getRecentDays(-30),
            offset:50,
            type:1,
            page:0,
            userId:this.userId
        }
        
        userStoreItems
		.getInstockoperaterecore(params)
		.then(res => {
			if(res.code === 200) {
				console.log('仓库库存操作日志',res.data)
                let mapList=new Map()
                this.totalAmount=0
               
                res.data.logs.forEach(p => {
                    p.createTime=utils.getCurrnetTime(p.createTime).slice(0,10)
                    p.decStock=Math.abs(p.decStock)
                   
                    
                    

                    let list=mapList.get(p.createTime)
                    if(!list || list == null || list == 'undefined'){
                        list={
                            outStock:0,
                            inStock:0,
                            returnStock:0
                        }
                    }
                    
                    if(p.type == 1 ){//出库扣减
                        
                        list.outStock+=p.decStock
                    }else if(p.type == 2){//入库单增加
                        list.inStock+=p.decStock
                    }else if(p.type == 3 ){//退货
                        list.returnStock+=p.decStock
                    }

                    mapList.set(p.createTime,list)

                })

                
                that.option.xAxis.data.forEach((p,index) => {
                    let ttp=mapList.get(p)
                    if(ttp){
                        that.option.series[0].data[index]=ttp.outStock
                        this.totalAmount+=ttp.outStock
                    }
                })
                console.log('mapList',mapList)
                console.log('that.option',that.option)
                that.option && myChart.setOption(that.option);
				
                
			}
		})
    },

    getType(){
        this.$emit('updateText',{type:this.type})
    },

    getData(item){
        console.log('remindData',this.remindData)
        this.storeId = item.value
        
        this.getStockRemindCopy()
    },

    upataOutOfStack(data){
        console.log(data)
        let arr=this.remindData.filter(p => {
            p.dayOfShip=Number(data.dayOfShip)
            p.salesAvg01=Number(p.salesAvg.toFixed(2))
            p.needStock01= data.type ? p.dayOfShip*2*p.salesAvg01-p.nowStock-p.shippedStock : p.dayOfShip*2*p.salesAvg01-p.nowStock
            return p
        })
        let list = arr.filter(p => {
            if( p.storeItem.storeId == this.storeId && p.needStock01> 0){
                return p
            }
        })
        console.log('arr',arr)

        list.forEach(i => {
            i.needStock01=Math.ceil(i.needStock01)
            
        })


        console.log('list',list)
        this.outOfstockReminder=list
        this.timeList[1].num=list.length

       

        

     
        
    },

    handleCurrentChange(val){
        console.log(val)
        this.page=Number(val-1)*10
        console.log('poage',this.page)
    },

    fuzzyMatch(str, key) {
        
       
        str == null ? '' : str
        if(typeof(str) == Number) {
            return str==key
        }

        console.log(typeof(key))

        if(typeof(key) == 'string' && str) {
            console.log(str,key,key.indexOf(str))
            let ttp=false
            if(key.indexOf(str) > -1 || str == key){
                ttp=true
            }
            return ttp
        }else {
            return false;
        }
        
       
    },

    getStockRemindCopy(){
				new Promise((resolve,reject) => {
                let that=this
				this.getStockRemind({userId:this.userId,storeId:this.storeId}).then(res => {
					console.log('852',res)
						if(res.code == 200) {
                            res.data.forEach(i => {

                                i.salesAvg01=Number(i.salesAvg.toFixed(2))
                                i.sevenday_estimatedSales=Math.floor(i.salesAvg01*7 * 100) / 100
                                i.fourteenday_estimatedSales=Math.floor(i.salesAvg01*14 * 100) / 100
                                i.thirty_estimatedSales=Math.floor(i.salesAvg01*30 * 100) / 100
                                i.daysAvailableSale=i.nowStock ? Math.floor(i.nowStock/i.salesAvg01 * 100) / 100 : 0
                            })
                            this.originRemindOrder=res.data
							this.remindData=res.data.filter(p => {
                                p.lastTime=p.lastTime ? utils.getCurrnetTime(p.lastTime) : this.$t("other.a354")
                                p.salesAvgMonthly=p.salesAvgMonthly.toFixed(2)
                                p.goodsValue=p.storeItem.storeNum*p.storeItem.cost
                                if(p.storeItem.storeId == this.storeId){
                                    return p
                                }
                            })

                            console.log('remindData',this.remindData)
							this.unsalable=this.remindData.filter(k => {
								if(k.unsalable){
									return k
								}
							})
                            this.timeList[0].num=this.remindData.length

							console.log('unsalable',this.unsalable)
                            this.timeList[2].num=this.unsalable.length
							let arr=this.remindData.filter(p => {
								p.salesAvg01=Number(p.salesAvg.toFixed(2))
								p.needStock01=p.dayOfShip*2*p.salesAvg01-p.nowStock
								return p
							})
                            console.log('arr',arr)
							let list = arr.filter(p => {
								if( p.storeItem.storeId == that.storeId && p.needStock01> 0){
									return p
								}
							})
                            console.log('list1112',list)
							resolve(list)
						}
					})
				}).then(res => {
					res.forEach(i => {
						i.needStock01=Math.ceil(i.needStock01)
                        
					})
					this.outOfstockReminderAmont=res.length
					this.outOfstockReminder=res
                    this.timeList[1].num=res.length
					console.log('缺货提醒11',res)
				})
			},

}
}

</script>
<style lang='scss' scoped>
.inventoryRp{
    background-color: white;
    margin: 20px 15px;
    padding: 10px;
    border-radius: 5px;
    width: calc(100% - 111px);


    .purchaseNum{
        display: inline-block;
        width: 20px;
        height: 20px;
        line-height: 20px;
        border-radius: 50%;
        background-color: red;
        color: #fff;
        text-align: center;
        position: relative;
        top: -11px;
        left: -11px;
    }

    .pong{
        display: flex;

        .okng{
            font-size: 14px;
            color: #919099;
            margin-right: 30px;
            cursor: pointer;
            margin-bottom: 15px;
            padding: 3px 10px;
            border-radius: 3px;
            
        }

        .active{
            background-color: #66b1ff;
            padding: 3px 10px;
            border-radius: 3px;
            color: #fff;
        }
    }

    .iknkg{
        width: 100%;
        height: 300px;
        display: flex;
        justify-content: center;
    }

    .remindData{
       display: flex;
       margin-top: 30px;
       justify-content: space-between;

        .btn{
            text-align: right;
            margin-bottom:10px;
            margin-right: 30px;
        }
    }

    .itemWrapper{
        display: flex;
        margin-bottom: 30px;
    }



    .sokng{
        display: inline-block;
        margin: 0 10px;
        cursor: pointer;
        color: #919099;
        padding: 3px ;
        margin: 3px 5px 10px 3px;
         
    }

    .store{
        width: 90px;
        margin-right:30px ;
        box-sizing: border-box;
        padding-top:5px;
        color: #919099;
    }

    .uykpg{
        width: 90px;
        margin-left:30px ;
        margin-right:30px ;
        box-sizing: border-box;
        padding-top:5px;
        color: #0d79f5;
        cursor: pointer;
    }
    .desc{
        width: 100%;

    }

    .active{
        color: #fff;
        background-color: #66b1ff;
        padding: 3px ;
        border-radius: 3px;
    }

    .pagination{
        text-align: right;
        margin-top: 18px;
        margin-right: 30 ;
    }

}
</style>